import { render, staticRenderFns } from "./PopImageZoom.vue?vue&type=template&id=4eec023b&lang=pug"
import script from "./PopImageZoom.vue?vue&type=script&lang=js"
export * from "./PopImageZoom.vue?vue&type=script&lang=js"
import style0 from "./PopImageZoom.vue?vue&type=style&index=0&id=4eec023b&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports